import {createSlice} from "@reduxjs/toolkit";
import {addError} from "src/slices/errors";
import {getOrderAvailableTenantList, getOrderCsr, getOrderDetails, getOrderProviderDetails} from "src/api/order";

const initialState = {
    currentOrder: {},
    providerDetails: {},
    savedCsr: "",
    loadingCurrentOrder: false,
    loadingProviderDetails: false,
    loadingSavedCsr: false,
    loadingOrderAvailableTenants: false,
    orderAvailableTenants: []
};

const slice = createSlice({
    name: "order",
    initialState,
    reducers: {
        setLoadingCurrentOrder(state, action) {
            state.loadingCurrentOrder = action.payload;
        },
        setLoadingProviderDetails(state, action) {
            state.loadingProviderDetails = action.payload;
        },
        setLoadingSavedCsr(state, action) {
            state.loadingSavedCsr = action.payload;
        },
        resetCurrentOrder(state) {
            state.currentOrder = initialState.currentOrder;
        },
        resetProviderDetails(state) {
            state.providerDetails = initialState.providerDetails;
        },
        resetSavedCsr(state) {
            state.savedCsr = initialState.savedCsr;
        },
        setCurrentOrder(state, action) {
            const {currentOrder} = action.payload;
            state.currentOrder = currentOrder;
        },
        setProviderDetails(state, action) {
            const {providerDetails} = action.payload;
            state.providerDetails = providerDetails;
        },
        setSavedCsr(state, action) {
            const {savedCsr} = action.payload;
            state.savedCsr = savedCsr;
        },
        setLoadingOrderAvailableTenants(state, action) {
            state.loadingOrderAvailableTenants = action.payload;
        },
        setOrderAvailableTenants(state, action) {
            const {orderAvailableTenants} = action.payload;
            state.orderAvailableTenants = orderAvailableTenants;
        }
    }
});

export const reducer = slice.reducer;

export const getCurrentOrder = orderId => async dispatch => {
    dispatch(slice.actions.setLoadingCurrentOrder(true));
    dispatch(slice.actions.resetCurrentOrder());

    let currentOrder = initialState.currentOrder;
    try {
        const getOrderResponse = await getOrderDetails(orderId);
        currentOrder = getOrderResponse.data;
    } catch (error) {
        dispatch(addError(error));
    }

    dispatch(slice.actions.setCurrentOrder({currentOrder}));
    dispatch(slice.actions.setLoadingCurrentOrder(false));
};

export const getProviderDetails = orderId => async dispatch => {
    dispatch(slice.actions.setLoadingProviderDetails(true));
    dispatch(slice.actions.resetProviderDetails());

    let providerDetails = initialState.providerDetails;
    try {
        const getProviderDetailsResponse = await getOrderProviderDetails(orderId);
        providerDetails = getProviderDetailsResponse.data;
    } catch (e) {
    }

    dispatch(slice.actions.setProviderDetails({providerDetails}));
    dispatch(slice.actions.setLoadingProviderDetails(false));
};

export const getSavedCsr = orderId => async dispatch => {
    dispatch(slice.actions.setLoadingSavedCsr(true));
    dispatch(slice.actions.resetSavedCsr());

    let savedCsr = initialState.savedCsr;
    try {
        const getSavedCsrResponse = await getOrderCsr(orderId);
        savedCsr = getSavedCsrResponse.data.csr;
    } catch (e) {
    }

    dispatch(slice.actions.setSavedCsr({savedCsr: savedCsr}));
    dispatch(slice.actions.setLoadingSavedCsr(false));
};

export const getOrderAvailableTenants = orderId => async dispatch => {
    dispatch(slice.actions.setLoadingOrderAvailableTenants(true));

    let orderAvailableTenants = initialState.orderAvailableTenants;
    try {
        const orderGetAvailableTenantListResponse = await getOrderAvailableTenantList(orderId);
        orderAvailableTenants = orderGetAvailableTenantListResponse.data;
    } catch (error) {
        dispatch(addError(error));
    }
    dispatch(slice.actions.setOrderAvailableTenants({orderAvailableTenants}));
    dispatch(slice.actions.setLoadingOrderAvailableTenants(false));
};

export default slice;
